import React, {useState} from "react"
import {useAuthStore} from "../../store/authStore"
import {EmailForm} from "../EmailForm"
import {OTPForm} from "../OTPForm"
import {AuthStep} from "../../types/auth"

export const LoginForm: React.FC = () => {
	const [currentStep, setCurrentStep] = useState<AuthStep>("email")
	const [email, setEmail] = useState("")

	const {status, sendOTP, verifyOTP} = useAuthStore()
	const isLoading = status === "authenticating"

	const handleSendOTP = async (emailAddress: string) => {
		setEmail(emailAddress)
		await sendOTP(emailAddress)
		setCurrentStep("otp")
	}

	const handleVerifyOTP = async (emailAddress: string, code: string) => {
		await verifyOTP(emailAddress, code)
	}

	const handleResendOTP = async (emailAddress: string) => {
		await sendOTP(emailAddress)
	}

	const handleBack = () => {
		setCurrentStep("email")
		setEmail("")
	}

	return (
		<div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
			<div className="max-w-md w-full space-y-8">
				<div className="text-center">
					<h1 className="text-3xl font-bold text-gray-900 dark:text-white">
						AiWave Administration Console
					</h1>
					<p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
						Enter your email to receive a verification code
					</p>
				</div>

				<div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md dark:shadow-gray-900/50 border border-transparent dark:border-gray-700">
					{currentStep === "email" ? (
						<EmailForm onSubmit={handleSendOTP} isLoading={isLoading} />
					) : (
						<OTPForm
							email={email}
							onSubmit={handleVerifyOTP}
							onResend={handleResendOTP}
							onBack={handleBack}
							isLoading={isLoading}
						/>
					)}
				</div>
			</div>
		</div>
	)
}
